import { createAction, props } from '@ngrx/store';
import { withGenesysCloudStoreNameSpace } from '../../common/action-namespace';
import { IntegrationConfig } from '../models/integration.model';

const withNameSpace = withGenesysCloudStoreNameSpace('Integrations');

export const initializeModule = createAction(withNameSpace('Initialize module'));

export const integrationsFetched = createAction(
  withNameSpace('Integrations fetched'),
  props<{ integrations: IntegrationConfig[] }>()
);

export const organizationPairingIntegrationLoaded = createAction(
  withNameSpace('Organization pairing integration loaded'),
  props<{ orgPairingIntegration: IntegrationConfig }>()
);
